import { Component, Input, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { debounceTime, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';

@Component({
  selector: 'app-commission-form',
  standalone: true,
  imports: [ ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,

    CommonModule],
  templateUrl: './comission-form.component.html',
  styleUrl: './comission-form.component.css'
})
export class ComissionFormComponent implements OnDestroy {
  @Input() orderData?: any;
  @Input() ladata: any = [];

  private destroy$ = new Subject<void>();

  comissionForm: FormGroup = new FormGroup({});
  taxRate: number = 0.21;
  constructor(private fb: FormBuilder, private modelService: ModelService, private alertService: AlertService,private authStateService: AuthStateService) {
    this.comissionForm = this.fb.group({
      broker_commission_base: ['', Validators.required],
      broker_commission_tax: ['', Validators.required],
      broker_commission_total: ['', Validators.required],
    });
    this.taxRate = this.authStateService.getSupplierTax() || 0.21;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }

      if (changes['orderData']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }
    }
  }

  private addDebouncedValueChange(control: any, callback: () => void): void {
    control?.valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(callback);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  refrescarFormulario() {
    this.updateFieldAccessibility();
    for (const key in this.orderData) {
      const control = this.comissionForm.controls[key];
      const value = this.orderData[key];
      if (control) {
        control.setValue(value);
      }
    }
    this.alertService.close();
  }


  updateFieldAccessibility() {
    var rules = this.orderData?.rules;
    // Deshabilitar todos los campos por defecto
    for (const field in this.comissionForm.controls) {
      if (this.comissionForm.controls.hasOwnProperty(field)) {
        this.comissionForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.comissionForm.get(field)?.enable();
      }
    }

  }

  calculateBrokerComissionFromBase(): void {
    const base = parseFloat(this.comissionForm.get('broker_commission_base')?.value);
    if (!isNaN(base)) {
      const tax = (base *  this.taxRate).toFixed(2);
      const total = (base * (1 + this.taxRate)).toFixed(2);

      this.comissionForm
        .get('broker_commission_tax')
        ?.setValue(tax, { emitEvent: false });
      this.comissionForm
        .get('broker_commission_total')
        ?.setValue(total, { emitEvent: false });
    }
  }

  calculateBrokerComissionFromTax(): void {
    const tax = parseFloat(this.comissionForm.get('broker_commission_tax')?.value);
    if (!isNaN(tax)) {
      const base = (tax /  this.taxRate).toFixed(2);
      const total = ((tax /  this.taxRate) * (1 + this.taxRate)).toFixed(2);

      this.comissionForm
        .get('broker_commission_base')
        ?.setValue(base, { emitEvent: false });
      this.comissionForm
        .get('broker_commission_total')
        ?.setValue(total, { emitEvent: false });
    }
  }

  calculateBrokerComissionFromTotal(): void {
    const total = parseFloat(this.comissionForm.get('broker_commission_total')?.value);
    if (!isNaN(total)) {
      const base = (total / (1 +  this.taxRate)).toFixed(2);
      const tax = ((total / (1 +  this.taxRate)) *  this.taxRate).toFixed(2);

      this.comissionForm
        .get('broker_commission_base')
        ?.setValue(base, { emitEvent: false });
      this.comissionForm
        .get('broker_commission_tax')
        ?.setValue(tax, { emitEvent: false });
    }
  }

  checkUpdateForm():boolean {
    if (this.comissionForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

}
